import React, { useEffect } from 'react';
import { Button, Card, Form, Image, Message } from 'semantic-ui-react';
import './LoginPage.scss';
import * as yup from 'yup';
import { Formik } from 'formik';
import { TextField } from './../common/FormFields';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import toast from 'react-hot-toast';

const validationSchema = yup.object({
  email: yup.string().required('A username is required'),
  password: yup.string().required('A password is required'),
});

const initialValues = {
  email: '',
  password: '',
  code: ' ',
};

const ResetPasswordPage = ({ match, updatePassword, errorMessage, successMessage }) => {
  const handleSubmit = credentials => {
    updatePassword({ ...credentials, code: match.params.token });
  };

  console.log({ errorMessage, successMessage });

  useEffect(() => {
    if (successMessage) {
      console.log('show success and navigate to home');
      toast.success(successMessage);
      window.location.href = '/login';
    }
  }, [successMessage]);

  return (
    <div className="gm-page login-page-body">
      <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValues}>
        {formik => (
          <Form id="login-form" onSubmit={formik.handleSubmit} error={Boolean(formik.touched && formik.errors)}>
            <Card className="login-card">
              <Card.Content textAlign="center">
                <Image src="/static/logo.svg" />
              </Card.Content>
              <Card.Content textAlign="center">
                <Card.Header>Update Your Password</Card.Header>
              </Card.Content>
              <Card.Content>
                {errorMessage && <Message error content={errorMessage} />}
                {successMessage && <Message success content={successMessage} />}
                <TextField
                  name="email"
                  label="Email address"
                  type="text"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  errorMessage={formik.errors.email}
                />

                <TextField
                  name="password"
                  label="Password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  errorMessage={formik.errors.password}
                />
              </Card.Content>
              <Card.Content extra>
                <Button type="submit" data-cy="submit" fluid positive>
                  Update Password
                </Button>
                <br />
                <Link to="/login">
                  <Button data-cy="submit" fluid>
                    Return to Login
                  </Button>
                </Link>
              </Card.Content>
            </Card>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const mapStateToProps = state => ({
  errorMessage: state.user.errorMessage,
  successMessage: state.user.successMessage,
  loggedIn: state.user.loggedIn,
});

const mapDispatchToProps = dispatch => ({
  updatePassword: bindActionCreators(actions.user.updatePassword, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);
